import React from 'react';
import PropTypes from 'prop-types';
import * as styled from './styles';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { BlobThree } from '../../vector';
import Image from '@components/Image';

function Stories2Sides(props) {
  const {
    heading,
    colorTheme,
    headingAlignment,
  } = props;

  const rawData = useStaticQuery(graphql`
  query Stories2Slides {
    allSanityStory(sort: {order: DESC, fields: _createdAt}, limit: 2) {
      nodes {
        title {
          en
          vi
          zh_Hans
          _key
        }
        _createdAt
        slug {
          current
        }
        image: heroImageExtended {
          credit
          link
          route {
            title {
              _type
              en
              vi
              zh_Hans
            }
            slug {
              current
            }
          }
          altText {
            en
            vi
            zh_Hans
            _type
          }
          image  {
            asset {
              fluid(
                maxWidth: 800,
                sizes: "(max-width: 600px) 100vw, 50vw"
                ){
                ...GatsbySanityImageFluid
              }
            }
          }
        }
        category {
          title {
            _key
            en
            vi
            zh_Hans
          }
          slug {
            current
          }
        }
      }
    }
  }
`);

  const getStoryCard = (story, index) => (
    <styled.Story size={index ? 'small' : 'large'}>
      <Link to={`/stories/${story.slug.current}`}>
        <Image
          fluid={story.image.image.asset.fluid}
          edge={1}
          ratio={3 / 4}
        />
      </Link>
      <styled.StoryData size={index ? 'small' : 'large'}>
        <styled.Tag level={300}>
          <Link to={`/stories${story.category.slug.current}`}>{story.category.title.en}</Link>
        </styled.Tag>
        <styled.Link level={300}><Link to={`/stories/${story.slug.current}`}>{story.title.en}</Link></styled.Link>
      </styled.StoryData>
    </styled.Story>
  );

  return (
    <styled.Wrapper colorTheme={colorTheme}>
      <styled.Inner colorTheme={colorTheme}>
        <styled.Content>
          <styled.Heading level={200} colorTheme={colorTheme} align={headingAlignment}>{heading}</styled.Heading>
          <styled.Stories>
            {rawData.allSanityStory.nodes.map((story, i) => getStoryCard(story, i))}
          </styled.Stories>
          <BlobThree />
        </styled.Content>
      </styled.Inner>
    </styled.Wrapper>
  );
}

Stories2Sides.propTypes = {
  heading: PropTypes.string.isRequired,
  headingAlignment: PropTypes.oneOf(['left', 'center', 'right']),
  colorTheme: PropTypes.oneOf(['dark-blue', 'green', 'orange', 'dark-purple', 'white']),
};

Stories2Sides.defaultProps = {
  colorTheme: 'dark-blue',
};

export default Stories2Sides;
